// extracted by mini-css-extract-plugin
module.exports = {"tab-list-item":"tab_tab-list-item__2WhgJ","tab-list-active":"tab_tab-list-active__2Qcrw"};